import { Component, OnInit } from '@angular/core';
import {AccessService} from '../services/access.service';

@Component({
  selector: 'app-term-schedule',
  templateUrl: './term-schedule.component.html',
  styleUrls: ['./term-schedule.component.css']
})
export class TermScheduleComponent implements OnInit {

  constructor(private accessService: AccessService) { }

    canAccessOIA() {
        return this.accessService.canAccessOIA();
    }

    canAccessEC() {
        return this.accessService.canAccessEC();
    }

  ngOnInit() {
  }

}
